module.exports = __webpack_public_path__ + "img/giraffa-traino.def91b45.jpg";